import { rotaRequest } from '../../../features/rota/rotaActions';
import ScheduledCheckAccess from './components/ScheduledCheckAccess';
import React, { useState, useEffect } from 'react';
import DefaultLayout from '../../../layouts/default';
import GuidanceWidgets from './components/GuidanceWidgets';
import OpeningCheckForm from './components/OpeningCheckForm';
import OpeningCheckHeader from './components/OpeningCheckHeader';
import CheckProgressWidget from './components/CheckProgressWidget';
import ComplianceRecordsSummary from './components/ComplianceRecordsSummary';
import PatFormChecklist from './components/PatFormChecklist';
import PatSummaryDashboardRow from './components/PatSummaryDashboardRow';
import { getLocalTodayString } from '../../../components/CreationDate';
import { useParams, useSearchParams } from "react-router-dom";

function DynamicCheckPage() {
  const { slug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const dateFromParams = searchParams.get("date");
  const [selectedDate, setSelectedDate] = useState(
    dateFromParams || getLocalTodayString()
  );

  useEffect(() => { setSelectedDate(dateFromParams || getLocalTodayString()); }, [dateFromParams, slug]);

  const taskId = searchParams.get('scheduledCheckId'), locationCode = searchParams.get('locationCode') || 'MAIN';
  const [discovery, setDiscovery] = useState({ loading: true, error: '' });
  useEffect(() => {
    if (taskId) { setDiscovery({ loading: false, error: '' }); return; }
    const controller = new AbortController(); setDiscovery({ loading: true, error: '' });
    const query = new URLSearchParams({ startDate: selectedDate, endDate: selectedDate, locationCode });
    rotaRequest(`/tasks?${query}`, {}, controller.signal).then(tasks => {
      if (controller.signal.aborted) return;
      const task = tasks.find(value => value.checklist.slug === slug);
      if (task) setSearchParams(previous => { const next = new URLSearchParams(previous); next.set('scheduledCheckId', task.id); next.set('date', selectedDate); next.set('locationCode', locationCode); return next; }, { replace: true });
      setDiscovery({ loading: false, error: '' });
    }).catch(failure => { if (!controller.signal.aborted) setDiscovery({ loading: false, error: failure.message }); });
    return () => controller.abort();
  }, [taskId, slug, selectedDate, locationCode, setSearchParams]);

  // Any slug containing one of these values will use the PAT layout
  const patCheckSlugs = [
    'pat-check',
    'staff-training-check'
  ];

  const isPatCheck = patCheckSlugs.some(pattern =>
    slug?.includes(pattern)
  );


  return (
    <DefaultLayout>
      <OpeningCheckHeader
        slug={slug}
        selectedDate={selectedDate}
        setSelectedDate={searchParams.get("scheduledCheckId") ? () => {} : setSelectedDate}
      />

      {discovery.loading ? <p className="p-4 text-sm text-gray-400">Loading check…</p> : discovery.error ? <p role="alert" className="p-4 text-sm text-red-600">{discovery.error}</p> : <ScheduledCheckAccess key={`${slug}:${selectedDate}:${searchParams.get("locationCode")}`} taskId={searchParams.get("scheduledCheckId")} >
      {isPatCheck ? (
            <>
              <PatSummaryDashboardRow />
              <PatFormChecklist slug={slug} selectedDate={selectedDate} />
            </>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-9">
              <OpeningCheckForm
                slug={slug}
                selectedDate={selectedDate} />
          </div>
            <div className="col-span-12 lg:col-span-3">
              <CheckProgressWidget slug={slug} selectedDate={selectedDate} />
              <ComplianceRecordsSummary  />
              <GuidanceWidgets />
            </div>
        </div>
      )}

    </ScheduledCheckAccess>}
    </DefaultLayout>
  );
}

export default DynamicCheckPage;